import { createFileRoute } from "@tanstack/react-router"

// Import the existing affiliate list page component
import AffiliateList from "@/features/jobs/affiliates/components/affiliate-list-page"

export const Route = createFileRoute("/_app/affiliate")({
  component: AffiliateListPage
})

function AffiliateListPage() {
  return <AffiliateList />
}
